import { render, staticRenderFns } from "./CompanyNewsDetails.vue?vue&type=template&id=fa5dda96&scoped=true&"
import script from "./CompanyNewsDetails.vue?vue&type=script&lang=js&"
export * from "./CompanyNewsDetails.vue?vue&type=script&lang=js&"
import style0 from "./CompanyNewsDetails.vue?vue&type=style&index=0&id=fa5dda96&scoped=true&lang=less&"
import style1 from "./CompanyNewsDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5dda96",
  null
  
)

export default component.exports